module.exports = __webpack_public_path__ + "static/media/DC_O_Timeless_Sforza_DKGrey.7d57eeb7.png";